import BigNumber from 'bignumber.js'

import { IExchangeData } from '@src/types/exchange'
import { IQuoteData } from '@src/types/order'

// Shortens a Solana address to show first 6 and last 3 characters
export const shortenSolanaAddress = (address: string) => {
    if (!address || address === '') return 'No Account connected'
    const match = address.match(/^([a-zA-Z0-9]{6})[a-zA-Z0-9]+([a-zA-Z0-9]{3})$/)
    if (!match) return address

    return `${match[1]}…${match[2]}`
}

// Calculates the Mach protocol fee from the sell data and quote response
export const extractMachFee = (sellData: IExchangeData, quoteResponse: IQuoteData) => {
    if (!sellData.token?.decimals) return 0

    try {
        const basisPoints = BigNumber(quoteResponse.bond_fee).dividedBy(BigNumber(10).exponentiatedBy(6))
        const feeAsInteger = BigNumber(quoteResponse.src_amount.toString()).multipliedBy(basisPoints)
        const feeAsDecimal = feeAsInteger.dividedBy(BigNumber(10).exponentiatedBy(sellData.token.decimals))
        const fee = feeAsDecimal.toNumber()

        if (isNaN(fee)) {
            return 0
        }

        return fee
    } catch (err) {
        return 0
    }
}
